import { FormValues, getValue, InputFormGroup } from "o4a-react";
import * as React from "react";
import * as Messages from "../../codegen/Messages";
import { Fields as TagDetailsFields, TagsEditPanel } from "../../components/TagsEditPanel/TagsEditPanel";
import { useOperation } from "../../hooks/useOperation";
import { OperationActionProps } from "../OperationTypes";
import { AdbsUpdateTagsProps, newAdbsUpdateTags } from "./AdbsUpdateTags";

export interface AdbsEditTagsProps extends OperationActionProps {
  databaseId: string | undefined;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  defaultTags?: { name: string; value: any; }[];
}

const AdbsEditTags = (
  { targetId, location, databaseId, defaultTags, onExecute, onCancel }: AdbsEditTagsProps,
): JSX.Element => {
  const { trigger: triggerUpdateTags } = useOperation<AdbsUpdateTagsProps>(newAdbsUpdateTags);

  return (
    <TagsEditPanel
      targetId={targetId}
      title={Messages.labels.editTags()}
      tagsDefaultValue={defaultTags || []}
      onSubmit={(formValues: FormValues) => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const tags: { name: string; value: any; }[] = getValue(formValues, TagDetailsFields.Tags, InputFormGroup);
        triggerUpdateTags({
          databaseId,
          tags,
          location,
          onExecute,
        });
      }}
      onClose={onCancel}
    />
  );
};

export const newAdbsEditTags = (
  props: AdbsEditTagsProps,
): JSX.Element => (<AdbsEditTags {...props} />);
